import {OrganizationTableauConfiguration} from '@models/organization/organization-tableau-configuration';

export class Organization {
  id: number;
  name: string;
  description: string;
  agreement: string;
  userAgreementUrl: string;
  privacyPolicyUrl: string;
  subTenants: number[];
  parentTenant: number | null;
  parentTenantName: string;
  externalId: string;

  tableauConfiguration: OrganizationTableauConfiguration;
  dashboardListPollingIntervalInSeconds?: number;

  constructor() {
    this.id = -1;
    this.name = '';
    this.description = '';
    this.agreement = '';
    this.userAgreementUrl = '';
    this.privacyPolicyUrl = '';
    this.parentTenant = null;
    this.subTenants = new Array<number>();
    this.parentTenantName = '';
    this.tableauConfiguration = new OrganizationTableauConfiguration();
    this.dashboardListPollingIntervalInSeconds = 10;
    this.externalId = '';
  }


}
